import {defineStore} from 'pinia'

export const useUserStore = defineStore('UserStore', {
    state: () => ({
        accessToken: '',
        username: '',
        userId: 0,
        companyId: 0,
        companyName: '',
        status: 0,
        rights: '',
        users: [],
        user: {},
        auditTrails: [],
        auditTrailsLastTwenty: [],
        userConfiguration: {},
        company: {},
        companyConfiguration: {},
        financialSummary: {},
        clients: [],
        tasks: [],
        prospects: [],
        appointments: [],
        invoices: [],
        payments: [],
        claims: [],
        products: [],
        practitioners: [],
        locations: [],
        billingPlans: [],
        suppliers: [],
        digitalForms: []
    }),
    persist: {
        storage: sessionStorage, // data in sessionStorage is cleared when the page session ends.
    },
    getters: {
        currentuser() {
            return this.username;
        }
    },
    actions: {
        setUserToken(userData) {
            console.log("[UserStore][setUserToken] Setting user data = ", userData);
            this.username = userData.username;
            this.accessToken = userData.accessToken;
            this.userId = userData.id;
            this.companyId = userData.companyId;
            this.status = 1;
            this.rights = userData.right;
        },
        setUser(userData) {
            console.log("[UserStore][setUser] Setting user data = ", userData);
            this.user = userData;
            this.companyName = userData.companyName;
            this.status = 1;
            this.rights = userData.right;
        },
        clearUser() {
            this.user = {};
            this.status = 0;
            this.rights = '';
            this.username = '';
            console.log("[UserStore][clearUser] Setting user data = ", this.user);
        },
        setUsers(usersData) {
            console.log("[UserStore][setAuditTrails] Setting usersData = ", usersData);
            this.users = usersData;
        },
        setAuditTrails(auditTrailsData) {
            console.log("[UserStore][setAuditTrails] Setting audit trails data = ", auditTrailsData);
            this.auditTrails = auditTrailsData;
        },
        setAuditTrailsLastTwenty(auditTrailsData) {
            console.log("[UserStore][setAuditTrails] Setting audit trails data = ", auditTrailsData);
            this.setAuditTrailsLastTwenty = auditTrailsData;
        },
        setUserConfiguration(userConfigurationData) {
            console.log("[UserStore][setCompanyConfiguration] Setting userConfigurationData data = ", userConfigurationData);
            this.userConfiguration = userConfigurationData;
        },
        setCompany(companyData) {
            console.log("[UserStore][setCompany] Setting companyData data = ", companyData);
            this.company = companyData;
        },
        setCompanyConfiguration(companyConfigurationData) {
            console.log("[UserStore][setCompanyConfiguration] Setting companyConfiguration data = ", companyConfigurationData);
            this.companyConfiguration = companyConfigurationData;
        },
        setFinancialSummary(financialSummaryData) {
            console.log("[UserStore][setCompanyConfiguration] Setting financialSummaryData data = ", financialSummaryData);
            this.financialSummary = financialSummaryData;
        },
        setClients(clientsData) {
            console.log("[UserStore][setCompanyConfiguration] Setting clientsData data = ", clientsData);
            this.clients = clientsData;
        },
        setTasks(tasksData) {
            console.log("[UserStore][setCompanyConfiguration] Setting tasksData data = ", tasksData);
            this.tasks = tasksData;
        },
        setProspects(prospectsData) {
            console.log("[UserStore][setCompanyConfiguration] Setting prospectsData data = ", prospectsData);
            this.prospects = prospectsData;
        },
        setAppointments(appointmentsData) {
            console.log("[UserStore][setCompanyConfiguration] Setting appointmentsData data = ", appointmentsData);
            this.appointments = appointmentsData;
        },
        setInvoices(invoicesData) {
            console.log("[UserStore][setCompanyConfiguration] Setting invoicesData data = ", invoicesData);
            this.invoices = invoicesData;
        },
        setPayments(paymentsData) {
            console.log("[UserStore][setCompanyConfiguration] Setting paymentsData data = ", paymentsData);
            this.payments = paymentsData;
        },
        setClaims(claimsData) {
            console.log("[UserStore][setCompanyConfiguration] Setting claimsData data = ", claimsData);
            this.claims = claimsData;
        },
        setProducts(productsData) {
            console.log("[UserStore][setCompanyConfiguration] Setting productsData data = ", productsData);
            this.products = productsData;
        },
        setPractitioners(practitionersData) {
            console.log("[UserStore][setCompanyConfiguration] Setting practitionersData data = ", practitionersData);
            this.practitioners = practitionersData;
        },
        setLocations(locationsData) {
            console.log("[UserStore][setCompanyConfiguration] Setting locationsData data = ", locationsData);
            this.locations = locationsData;
        },
        setBillingPlans(billingPlansData) {
            console.log("[UserStore][setCompanyConfiguration] Setting billingPlansData data = ", billingPlansData);
            this.billingPlans = billingPlansData;
        },
        setSuppliers(suppliersData) {
            console.log("[UserStore][setCompanyConfiguration] Setting suppliersData data = ", suppliersData);
            this.suppliers = suppliersData;
        },
        setDigitalForms(digitalFormData) {
            console.log("[UserStore][setDigitalForms] Setting digitalFormData data = ", digitalFormData);
            this.digitalForms = digitalFormData;
        }

    }
})
